import { ScrollSpy, ScrollSpyItem } from '@toggle/design-system';
import { Entity } from '@toggle/toggle';
import React from 'react';

import { EarningsLivePrice } from '../earnings-live-price/EarningsLivePrice';
import * as S from './Sidebar.styles';

export const Sidebar = ({
  entityData,
  containerRef,
  items,
}: {
  entityData: Entity;
  containerRef: React.RefObject<HTMLElement | null>;
  items: ScrollSpyItem[];
}) => {
  return (
    <S.SidebarContainer>
      <S.LivePriceWrapper>
        <EarningsLivePrice entity={entityData} />
      </S.LivePriceWrapper>
      <ScrollSpy items={items} containerRef={containerRef} />
    </S.SidebarContainer>
  );
};
